export const FileMaxSize = {

  regular: 5000000,
  bulkLoad: 15000000,
  stock: 35000000
}
